// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"06dde4cd0f888d28fab0","293":"a8e3619c9f139548d421","461":"1973414334d6792094ee","518":"221c2f38b166a4bcf112","779":"473e2d0210a0660c6ec4"}[chunkId] + ".js";
};